import { useState } from "react";
import validade from "./validate";

const useDeleteData = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const deleteData = async (endpoint, jsonBody) => {
    setLoading(true);
    setError(null);
    try {
      validade(localStorage.getItem("accessToken"));
         const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Token inv lido ou expirado.");
      }
      const res = await fetch(`https://api.lc-transportes.com/${endpoint}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(jsonBody),
      });

      if (!res.ok) {
        throw new Error(`Erro: ${res.status}`);
      }

      return res.ok; 
    } catch (err) {
      setError(err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return { deleteData, error, loading };
};

export default useDeleteData;

